import { Box, Flex, Image, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";

export function ModalMarcation() {
  return (
    <Flex direction="column" m="0 auto">
      <Image
        maxH="400px"
        w="auto"
        src="https://cdn.pneufree.com.br/CMS/images/icons/geral/02-17-2021-12-11pneu-marcado-ok.jpg"
        alt="Pneu Marcado"
      />
      <Box w="100%" h="60px" bg="blue.900" p="1rem" mb="1rem">
        <Text textStyle="MBold" fontSize="h1" color="yellow.900">
          PNEU MARCADO
        </Text>
      </Box>
      <Box fontSize="text1" textStyle="Regular" mb="1rem">
        <Text mt="1rem">
          O pneu marcado é um produto homologado e desenvolvido para um determinado veículo em
          cooperação entre o fabricante do pneu e a montadora, para que sejam feitos ajustes finos
          de acordo com os objetivos de cada projeto (conforto, controle, equilíbrio, desempenho,
          etc.). Fazendo uma analogia, funciona como um terno feito sob medida.
        </Text>
        <Text mt="1rem">
          <Text textStyle="Bold"> IMPORTANTE:</Text> Os pneus sem marcação de montadora não têm
          qualidade inferior em relação aos marcados. O que os diferencia é a possibilidade de dar
          foco maior ou menor em cada uma de suas características. Abaixo confira uma tabela que vai
          te ajudar a reconhecer a marcação para cada montadora:
        </Text>
      </Box>
      <Table variant="striped" colorScheme="gray">
        <Thead>
          <Tr alignItems="center">
            <Th>MONTADORA</Th>
            <Th>MARCAÇÃo</Th>
          </Tr>
        </Thead>
        <Tbody>
          <Tr>
            <Td>ALFA ROMEO</Td>
            <Td>AR • ARR</Td>
          </Tr>
          <Tr>
            <Td>ALPINA</Td>
            <Td>ALP</Td>
          </Tr>
          <Tr>
            <Td>ASTON MARTIN</Td>
            <Td>A6A • A7A • AM4 • AM8 • AM9 • AMP • AMS • AMV • A8A</Td>
          </Tr>
          <Tr>
            <Td>AUDI</Td>
            <Td>AO • AO1 • AOE • RO1 • RO2</Td>
          </Tr>
          <Tr>
            <Td>BENTLEY</Td>
            <Td> B • B1 • BC • BL</Td>
          </Tr>
          <Tr>
            <Td>BMW</Td>
            <Td>&#9733;</Td>
          </Tr>
          <Tr>
            <Td>DALLARA</Td>
            <Td>ME2</Td>
          </Tr>
          <Tr>
            <Td>FERRARI</Td>
            <Td>F • F01 • F02 • F03</Td>
          </Tr>
          <Tr>
            <Td>HYUNDAI</Td>
            <Td>HN • GOE</Td>
          </Tr>
          <Tr>
            <Td>JAGUAR</Td>
            <Td>J • JRS</Td>
          </Tr>
          <Tr>
            <Td>LAMBORGHINI</Td>
            <Td>L • L1</Td>
          </Tr>

          <Tr>
            <Td>LAND ROVER</Td>
            <Td>L • L1</Td>
          </Tr>
          <Tr>
            <Td>LOTUS</Td>
            <Td>LS</Td>
          </Tr>
          <Tr>
            <Td>MASERATI</Td>
            <Td>MGT</Td>
          </Tr>
          <Tr>
            <Td>MCLAREN </Td>
            <Td>MC • MC1 • MC2 • MC-C</Td>
          </Tr>
          <Tr>
            <Td>MERCEDES BENZ</Td>
            <Td>MO • MO1 • MOE • MO-S • MO-V</Td>
          </Tr>
          <Tr>
            <Td>MINI</Td>
            <Td>&#9733;</Td>
          </Tr>
          <Tr>
            <Td>NIO</Td>
            <Td>I</Td>
          </Tr>
          <Tr>
            <Td>PAGANI</Td>
            <Td>HP</Td>
          </Tr>
          <Tr>
            <Td>PORSCHE</Td>
            <Td>N0 • N1 • N2 • N3 • N4 • N5 • NA0 • NA1 • NF0</Td>
          </Tr>
          <Tr>
            <Td>TESLA </Td>
            <Td>T0</Td>
          </Tr>
          <Tr>
            <Td>VOLVO</Td>
            <Td> VOL</Td>
          </Tr>
        </Tbody>
      </Table>
    </Flex>
  );
}
